import { connect, Router, useRouter } from "../../atoms/DependencyHelper";
import config from "../../../config/index";
import {
  displayHideUpgradeModal,
  clearUpgradeJourney,
  updateCanReciveOTP,
  updateMsisdnStatus,
  updateEligibiltyCheckStatus,
  generateOneTimePin,
  getAllEligibility,
  fetchAlternateNumbers,
  generateOTP,
  getEligibilityForAlternativeNumbers,
  eligibilityForLinkedNumbersList,
  fetchDisplayDetails,
  updateJourneyStatus,
  displayHideUpgradeTopbanner,
  updateSelectedData,
  fetchCreditFilters,
  checkIfdealQualifies,
  resetInvalidOtps,
  toggleSnackBar,
  updateUnmaskedMsisdn,
  updateLinkedNumber,
  getRecommendedDeals,
  displayInvalidOTPError,
  updateData,
  addDealToCart,
} from "../../../Redux/actions/upgradeAction";
import {
  setMaxRecurring
} from "../../../Redux/actions/dealBuilderAction";
import styles from "./UpgradeContainer.module.scss";
import { useState, useEffect, useCallback } from "react";
import UpgradeComponent from "../../molecules/upgradeModal/UpgradeModal";
import * as Analytics from "../../../services/analyticsUtag";
import SnackBar from "../../atoms/snackBar/SnackBar";
import ErrorTooltip from "../../molecules/errorToolTip/ErrorTooltip";
import {
  checkChildUpgradable,
  checkifUpgradableAndC3D,
  errorCodes,
  upgradeStages,
  checkUserNextDueDateforUpgrade,
  maskMsisdn,
  checkIfFromDetailPage,
  checkIfFromDealDetailPage,
  fetchAffordCode,
  handoverUpgradeeSession,
  checkIfHiddenDropdown,
  resetFiltersOnStopUpgrade,
} from "../../../services/upgradeService";
import labels from "../../../config/labels";
import TooltipContainer from "../../atoms/toolTip/Tooltip";
import SnackBarWithButton from "../../atoms/snackBar/SnackBarWithButton";
import {
  hideSpinner,
  showSpinner,
  titleCase,
  debounce,
} from "../../../utils/helperServices";
import { componentResize } from "../../../utils/helperServices";
import SnackBarWithDismiss from "../../atoms/snackBar/SnackBarWithDismiss";

const UpgradeContainer = (props) => {
  const numRegEx = RegExp(/^[0-9]*$/);
  const cellPhoneRegEx = RegExp(/^0[0-9]*$/);
  const msisdnRegEx = RegExp(/^27[0-9]*$/);
  const router = useRouter();
  const [msisdn, setMsisdn] = useState(props.unMaskedMsisdn || "");
  const [otpCheckBox, setOtpCheckBox] = useState(true);
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [errorMessage, setErrorMessage] = useState();
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showErrorToolTip, setShowErrorToolTip] = useState({
    visible: false,
    message: "",
  });
  const [selectedNumber, setSelectedNumber] = useState("");
  const [newOtp, setNewOtp] = useState();
  const [mahConsentCheck, setMahConsentCheck] = useState(false);
  const [resultNumbers, setResultNumbers] = useState([]);
  const [selectedResultNumber, setSelectedResultNumber] = useState("");
  const [showAddnlInfo, setShowAddnlInfo] = useState(false);
  const [selectedLinkedNumber, setSelectedLinkedNumber] = useState(
    props.unMaskedMsisdn
  );
  const [numberWhereOTPSent, setNumberWhereOTPSent] = useState("");
  const [currentPageName, setCurrentPageName] = useState("");
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const maxRetriesCount = config.maxRetriesCount;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const isMobile = componentResize();
  const toggleModal = (upgradeCheckDone) => {
    const status = upgradeCheckDone ? upgradeCheckDone : props.upgradeCheckDone;
    if (Router.asPath != "/shopping/upgrade" || !status) {
      resetUpgradeJourney();
    }
    props.displayHideUpgradeModal(!props.showModal);
    Analytics.setPageName(currentPageName);
    setCurrentPageName("");
  };

  const dismissModal = () => {
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: `${pageName}: dismiss`,
      ...getUtagViewData(),
    });

    closeModal();
  };
  useEffect(() => {
    if(window?.location.reload){
      if (props.journeyStatus == (upgradeStages.NUMBER_ENRTY ||
        upgradeStages.NUMBER_SELECTupgradeStages.OTP_ENRTY ||
        upgradeStages.UPGRADE_RESULT ||
        upgradeStages.TECHNICAL_ERROR ||
        upgradeStages.ELIGIBLE_NUMBER_SELECT) || !props.upgradeCheckDone)
        {
         props.clearUpgradeJourney();
        }
     }
   },[]);
  const closeModal = () => {
    if (props.userLoggedIn) {
      props.displayHideUpgradeModal(!props.showModal);
      Analytics.setPageName(currentPageName);
      setCurrentPageName("");
    } else {
      toggleModal();
      if (!(Router.asPath == "/shopping/upgrade") || !props.upgradeCheckDone) {
        props.clearUpgradeJourney();
      }
    }
    if (props.invalidOTPTries > 0 && props.invalidOTPTries < maxRetriesCount) {
      props.displayInvalidOTPError(false);
      setShowErrorToolTip({ visible: false, message: "" });
    }
    if (
      props.upgradeCheckDone == true &&
      props.journeyStatus == upgradeStages.OTP_ENRTY
    ) {
      props.clearUpgradeJourney();
      resetFiltersOnStopUpgrade(Router?.pathname);
      hideSpinner();
    }
  };

  const resetUpgradeJourney = () => {
    setShowErrorToolTip({ visible: false, message: "" });
    setOtp(Array(4).fill(""));
    setMsisdn("");
    setOtpCheckBox(true);
    setMahConsentCheck(false);
    setShowAddnlInfo(false);
    setResultNumbers([]);
    setSelectedResultNumber("");
    setErrorMessage();
  };

  useEffect(() => {
    if ((!props.userLoggedIn && !props.allUpgradesData.length) || (props.userLoggedIn && props.allUpgradesData.length > 0)) {
      const msisdnsFilter = props.subscriptions.filter((subs) => {
        if (subs.type === 1) {
          return subs.subscriptionId;
        }
      });
      const msisdns = msisdnsFilter.map((item) => item.subscriptionId);

      if (msisdns.length > 0) {
        showSpinner();
        props.eligibilityForLinkedNumbersList(
            msisdns,
            props?.profileData?.firstname
        );
      }
    }
  }, [props.userLoggedIn]);

  const recommendedNavigate = () => {
    props.toggleSnackBar(false);
    if (checkifUpgradableAndC3D(props.resultCode)) {
      showSpinner();
      router.push(`${shoppingUrlPrefix}/upgrade`).then(() => {
        window.scrollTo(0, 0);
        props.updateEligibiltyCheckStatus(true);
        hideSpinner();
      });
    } else {
      props.displayHideUpgradeModal(true);
    }

    Analytics.link({
      link_type: "o",
      link_name: `${Analytics.getUtagData(["page_name"]).page_name}: snackbar ${
        labels.upgrade.lbl_snackbar_btn_text
      }`,
      ...getUtagViewData(),
    });
  };

  const closeUpgradeSnackBar = () => {
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: `${
        Analytics.getUtagData(["page_name"]).page_name
      }: snackbar dismiss`,
      ...getUtagViewData(),
    });
    props.toggleSnackBar(false);
  };

  useEffect(() => {
    let message = "";
    let occurance = "";
    if (props.invalidOTPTries > 0 && props.invalidOTPTries < maxRetriesCount) {
      if (props.invalidOTPTries === maxRetriesCount - 1) {
        message = labels.upgrade.lbl_invalid_otp_try_2;
        occurance = "twice";
      } else {
        message = labels.upgrade.lbl_invalid_otp_try_1;
        occurance = "once";
      }
      setOtp(Array(4).fill(""));
      if (props.isDisplayInvalidOTPError) {
        setShowErrorToolTip({ visible: true, message: message });
      }
      Analytics.view({
        ...getUtagViewData(),
        page_name: `shopping: upgrade: eligibility: otp failed ${occurance}`,
      });
    } else if (props.invalidOTPTries === maxRetriesCount) {
      showSpinner();
      resetUpgradeJourney();
      props.clearUpgradeJourney();
      router.push("/shopping/error").then(() => {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    }
  }, [props.invalidOTPTries]);

  useEffect(() => {
    if (showSnackBar) {
      let timer = setTimeout(() => closeSnackBar(), 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  useEffect(() => {
    async function getCreditfilters() {
      try {
        let isProductPage = checkIfFromDetailPage(Router.asPath);
        let isDealBuilderPage = Router.asPath.includes("/shopping/deal-builder");
        let affordCode = fetchAffordCode(Router.asPath);
        if (checkifUpgradableAndC3D(props.resultCode) && (isProductPage || isDealBuilderPage)) {
          let creditFilters = await props.fetchCreditFilters(
            props.upgradeResponse.msisdn
          );
          if (!creditFilters.fail) {
            const {
              financeIndicator,
              total_monthly_payment,
              deviceInstallment,
            } = creditFilters || {};

            props.setMaxRecurring(total_monthly_payment);

            if (checkIfFromDealDetailPage(Router.asPath)) {
              let result = await props.getRecommendedDeals(
                props.unMaskedMsisdn,
                "",
                "",
                "",
                total_monthly_payment,
                Number(deviceInstallment),
                financeIndicator,
                props.devicePrice?.sku,
                props.upgradeResponse?.simOnlyUpgradeFlg
              );
              if (result.fail) {
                props.displayHideUpgradeModal(true);
                props.updateJourneyStatus(
                  errorCodes.service_down,
                  upgradeStages.TECHNICAL_ERROR
                );
              } else {
                if (result?.response?.data?.isUpgradeAffordable === "N") {
                  props.fetchDisplayDetails(affordCode);
                } else {
                  props.fetchDisplayDetails(props.resultCode);
                }
              }
            } else if (
              financeIndicator &&
              financeIndicator === "Y" &&
              Number(props.devicePrice.devicePrice) >
                Number(total_monthly_payment)
            ) {
              props.fetchDisplayDetails(affordCode);
            } else if (
              financeIndicator &&
              financeIndicator === "N" &&
              (Number(props.devicePrice.devicePrice) >
                Number(total_monthly_payment) ||
                Number(props.devicePrice.installment) >
                  Number(deviceInstallment))
            ) {
              props.fetchDisplayDetails(affordCode);
            } else {
              props.fetchDisplayDetails(props.resultCode);
            }
          } else {
            props.displayHideUpgradeModal(true);
            props.updateJourneyStatus(
              errorCodes.service_down,
              upgradeStages.TECHNICAL_ERROR
            );
          }
        } else {
          props.fetchDisplayDetails(props.resultCode);
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (
      props.resultCode &&
      (props.journeyStatus === upgradeStages.UPGRADE_RESULT ||
        props.journeyStatus === upgradeStages.TECHNICAL_ERROR)
    ) {
      getCreditfilters();
    }
  }, [props?.journeyStatus, props.resultCode]);

  // Check for upgrade eligibility pre-checkout

  useEffect(() => {
    let showMultipleNumbers = true;
    let upgradableNumbers = 0;
    let foundMsisdn = false;
    if (props?.allUpgradesData?.length > 0) {
      const msisdns = props.allUpgradesData.map((item, index) => {
        if (maskMsisdn(item.msisdn) === maskMsisdn(props.unMaskedMsisdn)) {
          foundMsisdn = true;
          showMultipleNumbers = item?.mah;
          setSelectedResultNumber(
            item.upgradeEligible
              ? `${maskMsisdn(item.msisdn)} (Upgradeable)`
              : `${maskMsisdn(item.msisdn)} (Not upgradeable)`
          );
        }
        if (item.upgradeEligible) {
          upgradableNumbers = upgradableNumbers + 1;
        }
        return {
          num: item.msisdn,
          id: index + 1,
          label: item.upgradeEligible
            ? `${maskMsisdn(item.msisdn)} (Upgradeable)`
            : `${maskMsisdn(item.msisdn)} (Not upgradeable)`,
          upgradeEligible: item.upgradeEligible,
        };
      });
      if (showMultipleNumbers) {
        setShowAddnlInfo(upgradableNumbers > 1);
        setResultNumbers(msisdns);
      } else {
        setResultNumbers(
          msisdns.filter(
            (item) => maskMsisdn(item.num) === maskMsisdn(props.unMaskedMsisdn)
          )
        );
      }
      if (!foundMsisdn) {
        setResultNumbers([]);
        setSelectedResultNumber(
          props.upgradeResponse.upgradeEligible
            ? `${maskMsisdn(props.upgradeResponse.msisdn)} (Upgradeable)`
            : `${maskMsisdn(props.upgradeResponse.msisdn)} (Not upgradeable)`
        );
      }
    }
  }, [props.allUpgradesData]);
  useEffect(() => {
    setSelectedResultNumber(
      props?.upgradeResponse?.upgradeEligible
        ? `${maskMsisdn(props?.upgradeResponse?.msisdn)} (Upgradeable)`
        : `${maskMsisdn(props?.upgradeResponse?.msisdn)} (Not upgradeable)`
    );
  }, [props.upgradeResponse]);
  const handleNewSelect = (selectedValue) => {
    setSelectedResultNumber(selectedValue);
    let upgradableNumbers = 0;
    resultNumbers.forEach((item) => {
      if (item.label === selectedValue) {
        const newResult = props.allUpgradesData.find(
          (value) => value.msisdn === item.num
        );
        props.updateData(newResult);
      } else {
        if (item.upgradeEligible) {
          upgradableNumbers = upgradableNumbers + 1;
        }
      }
    });
    setShowAddnlInfo(upgradableNumbers > 0);
  };

  const closeSnackBar = () => {
    setShowSnackBar(false);
  };

  const getErrorMessage = (value) => {
    if (value && value.length > 0) {
      if (numRegEx.test(value)) {
        if (!(cellPhoneRegEx.test(value) || msisdnRegEx.test(value))) {
          setErrorMessage(labels.upgrade.lbl_error_zero);
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage(labels.upgrade.lbl_error_numbers);
      }
    } else {
      setErrorMessage(labels.upgrade.lbl_error_enter_number);
    }
  };

  const getUtagViewData = () => {
    return Analytics.getUtagData([
      "visitor_customer_id",
      "visitor_login_status",
      "visitor_subscription_type",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "page_site_section_lvl_4",
      "visitor_msisdn_hash",
      "page_name",
      "page_channel",
      "page_master_tab",
      "upgrade_eligibility_status",
      "upgrade_ineligible_reason",
      "upgrade_eligible_date",
      "upgrade_customer_type",
    ]);
  };

  const checkAndUpdateMsisdn = (event) => {
    getErrorMessage(event.target.value);
    setMsisdn(event.target.value);
  };
  const handleOnBlur = () => {
    if (errorMessage) {
      Analytics.link({
        page_name: Analytics.getPageName(),
        page_form_name: labels.upgrade.lbl_enter_msisdn_title,
        page_form_event: "error",
        page_errors: errorMessage,
        page_error_type: "form",
      });
    }
  };
  const updateCheckBox = (e) => {
    setOtpCheckBox(!otpCheckBox);
    props.updateCanReciveOTP(!otpCheckBox);
    let pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: `${pageName}: ${
        otpCheckBox ? "I can't use sms" : "I can use sms"
      }`,
      ...getUtagViewData(),
    });
  };

  const validateOTP = () => {
    const otpValue = otp.join("");
    Analytics.link({
      link_type: "o",
      link_name: `${Analytics.getUtagData(["page_name"]).page_name}: ${
        labels.upgrade.lbl_btn_submit_otp
      }`,
      ...getUtagViewData(),
    });
    //call for validating OTP
    setShowErrorToolTip({ visible: false, message: "" });
    if (otpCheckBox && props.canReciveOTP) {
      props
        .getAllEligibility(msisdn || props.unMaskedMsisdn, otpValue)
        .then(() => {
          setOtp(Array(4).fill(""));
          setOtpCheckBox(true);
        });
    } else {
      props
        .getEligibilityForAlternativeNumbers(
          msisdn || props.unMaskedMsisdn,
          selectedNumber || props.msisdnEntered,
          otpValue
        )
        .then(() => {
          setOtp(Array(4).fill(""));
          setOtpCheckBox(true);
        });
    }
    props.updateUnmaskedMsisdn(msisdn || props.unMaskedMsisdn);
  };

  const getLinkedNumbers = () => {
    //call to fetch linked numbers to msisdn
    props.fetchAlternateNumbers(msisdn);
  };

  const fetchOTP = async () => {
    //call for sending OTP
    props.generateOneTimePin(msisdn);
    setNumberWhereOTPSent(maskMsisdn(msisdn));
  };

  const generateOTPforLinkedNumber = (value) => {
    //props.updateMsisdnStatus(value, true);
    props.generateOTP(msisdn, value);
    setSelectedNumber(value);
    setNumberWhereOTPSent(maskMsisdn(value));
    props.updateLinkedNumber(value);
  };

  const onClickContinue = () => {
    Analytics.link({
      link_type: "o",
      link_name: `${Analytics.getUtagData(["page_name"]).page_name}: ${
        labels.upgrade.lbl_btn_continue
      }`,
      ...getUtagViewData(),
    });
    if (otpCheckBox) {
      fetchOTP();
    } else {
      getLinkedNumbers();
    }
    props.updateUnmaskedMsisdn(msisdn);
    props.updateMsisdnStatus(maskMsisdn(msisdn), true);
  };

  const resendOTP = () => {
    //call for resend OTP
    const pageName = Analytics.getUtagData(["page_name"])?.page_name;
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: `${pageName}: resend otp`,
      ...getUtagViewData(),
    });
    if (otpCheckBox) {
      fetchOTP();
    } else {
      props.generateOTP(msisdn, selectedNumber);
    }
    setShowSnackBar(true);
    closeErrorToolTip();
  };

  const navigateTo = (url) => {
    if (!checkifUpgradableAndC3D(props?.resultCode?.toLowerCase())) {
      closeModal();
      if (url) {
        navigateRedirection(url);
      }
    } else {
      props.updateSelectedData(props.upgradeResponse);
      setMahConsentCheck(false);
      props.displayHideUpgradeTopbanner(true);
      toggleModal(true);
      props.updateEligibiltyCheckStatus(true);
      props.resetInvalidOtps();

      if (checkIfFromDealDetailPage(Router.asPath)) {
        props
          .getRecommendedDeals(
            props.unMaskedMsisdn,
            "",
            "",
            "",
            props.creditFilters?.total_monthly_payment,
            Number(props.creditFilters?.deviceInstallment),
            props.creditFilters?.financeIndicator,
            props.devicePrice?.sku,
            props.upgradeResponse?.simOnlyUpgradeFlg
          )
          .then((result) => {
            if (result.fail) {
              props.displayHideUpgradeModal(true);
              props.updateJourneyStatus(
                errorCodes.service_down,
                upgradeStages.TECHNICAL_ERROR
              );
            } else {
              if (result?.response?.data?.isUpgradeAffordable === "N") {
                navigateRedirection(url);
              } else {
                handoverUpgradeeSession(
                  props.canReciveOTP,
                  props.isChildAllowed,
                  props.upgradeResponse
                );
                // navigateRedirection(props.upgradeLink.link);
                props.addDealToCart(true);
              }
            }
          });
      } else if (checkIfFromDetailPage(Router.asPath)) {
        if (
          props.creditFilters.financeIndicator === "Y" &&
          Number(props.devicePrice.devicePrice) >
            Number(props.creditFilters.total_monthly_payment)
        ) {
          navigateRedirection(url);
        } else if (props.creditFilters.financeIndicator === "N") {
          if (
            Number(props.devicePrice.devicePrice) >
            Number(props.creditFilters.total_monthly_payment)
          ) {
            navigateRedirection(url);
          } else if (
            Number(props.devicePrice.installment) >
            Number(props.creditFilters.deviceInstallment)
          ) {
            navigateRedirection(url);
          } else {
            navigateRedirection(props.upgradeLink.link);
          }
        } else {
          navigateRedirection(props.upgradeLink.link);
        }
      } else {
        props.fetchCreditFilters(props?.upgradeResponse?.msisdn);
        handoverUpgradeeSession(
          props.canReciveOTP,
          props.isChildAllowed,
          props.upgradeResponse
        );
      }
    }
  };

  const navigateRedirection = (url) => {
    showSpinner();
    handoverUpgradeeSession(
      props.canReciveOTP,
      props.isChildAllowed,
      props.upgradeResponse
    );
    router?.push(url).then(() => {
      hideSpinner();
    });
  };
  useEffect(() => {
    let numArray = [];
    for (let i = 0; i < otp.length; i++) {
      if (otp[i] != "") {
        numArray.push(otp[i]);
      }
    }
    setNewOtp(numArray);
  }, [otp]);
  const displayErrorPopup = () => {
    Analytics.link({
      link_type: "o",
      link_name: `${Analytics.getUtagData(["page_name"]).page_name}: can't otp`,
      ...getUtagViewData(),
    });
    props.updateJourneyStatus(errorCodes.otp_service_down);
  };

  const fetchMaxNumber = (value) => {
    let maxNumber = 11;
    if (cellPhoneRegEx.test(value)) {
      maxNumber = 10;
    }
    return maxNumber;
  };

  const CellNumberInput = {
    iconUrl: `${imagePrefix}/assets/images/deal-builder/upgrade-black.svg`,
    title: labels.upgrade.lbl_enter_msisdn_title,
    analyticTitle: "shopping: upgrade: eligibility: pop up",
    description: labels.upgrade.lbl_enter_msisdn_desc,
    input: true,
    inputTitle: labels.upgrade.lbl_enter_msisdn_input_title,
    onChangeHandler: checkAndUpdateMsisdn,
    onBlurHandler: handleOnBlur,
    errorMessage: errorMessage,
    maxLength: fetchMaxNumber(msisdn),
    checkbox: true,
    checkValue: otpCheckBox,
    checkBoxText: labels.upgrade.lbl_enter_msisdn_checkbox_text,
    checkBoxHandler: updateCheckBox,
    primaryButtonText: labels.upgrade.lbl_btn_continue,
    primaryButtonDisabled:
      !(msisdn?.length === fetchMaxNumber(msisdn)) || errorMessage,
    primaryButtonStyle:
      !(msisdn?.length === fetchMaxNumber(msisdn)) || errorMessage
        ? "solid light gray"
        : "solid red",
    onClickHandlerPrimary: onClickContinue,
  };

  const OTPInput = {
    title: labels.upgrade.lbl_enter_otp_title,
    analyticTitle: "shopping: upgrade: eligibility: enter otp",
    description: isMobile
      ? `${labels.upgrade.lbl_enter_otp_desc_prefix} ${
          numberWhereOTPSent ? numberWhereOTPSent : props.msisdnEntered
        } ${labels.upgrade.lbl_enter_otp_desc_suffix}`
      : `${labels.upgrade.lbl_enter_otp_desc_prefix} ${
          numberWhereOTPSent ? numberWhereOTPSent : props.msisdnEntered
        }.<br/>${labels.upgrade.lbl_enter_otp_desc_suffix_v2}`,
    otpInput: true,
    invalidOTPTries: props?.invalidOTPTries,
    otpValue: otp,
    otpHandler: setOtp,
    textButton: labels.upgrade.lbl_btn_resend_otp,
    textButtonHandler: resendOTP,
    primaryButtonText: labels.upgrade.lbl_btn_submit_otp,
    primaryButtonStyle:
      newOtp && newOtp.length == 4 ? "solid red" : "solid light gray",
    primaryButtonDisabled: !(newOtp && newOtp.length == 4),
    onClickHandlerPrimary: validateOTP,
  };
  const linkedNumbersData = {
    title: labels.upgrade.lbl_select_number_title,
    analyticTitle: "shopping: upgrade: eligibility: send otp",
    description: labels.upgrade.lbl_select_number_desc,
    mobileNumbers: true,
    numbers: props.linkedNumbersList,
    selectedNumber: selectedNumber,
    handleOptionClick: generateOTPforLinkedNumber,
    textButton: labels.upgrade.lbl_btn_none_otp,
    textButtonHandler: displayErrorPopup,
  };

  const updateMahConsentCheck = (e) => {
    setMahConsentCheck(!mahConsentCheck);
    Analytics.link({
      ...getUtagViewData(),
      page_tool_event: "use",
      page_tool_name: `${Analytics.getUtagData(["page_name"]).page_name}: ${
        mahConsentCheck ? "mah can't provide otp" : "mah can provide otp"
      }`,
    });
  };
  const ToolTipComponent = (
    <span className={styles.tooltipCheckbox}>
      {labels.upgrade.lbl_tooltip_prefix_text}
      <span>
        <TooltipContainer text={labels.upgrade.lbl_tooltip_text}>
          <span>{labels.upgrade.lbl_tooltip_message}</span>
        </TooltipContainer>{" "}
      </span>
      {labels.upgrade.lbl_tooltip_suffix_text}
    </span>
  );

  const handleResultCodePrimaryCTA = () => {
    if (checkIfFromDealDetailPage(Router.asPath)) {
      Analytics.link({
        ...getUtagViewData(),
        link_type: "o",
        link_name: `${
          Analytics.getUtagData(["page_name"]).page_name
        }: ${ctaText()}`,
        ...props?.devicePrice?.analyticsOptions,
      });
    } else {
      Analytics.link({
        ...getUtagViewData(),
        link_type: "o",
        link_name: `${
          Analytics.getUtagData(["page_name"]).page_name
        }: ${ctaText()}`,
      });
    }
    if (props?.upgradeDisplayData?.primaryCTAType) {
      const url = `${props?.upgradeDisplayData?.primaryCTAURL}?bucket=${props?.upgradeDisplayData?.leadType}`;
      navigateTo(url);
    } else {
      navigateTo(props?.upgradeDisplayData?.primaryCTAURL);
    }
  };

  const handleResultCodeSecondaryCTA = () => {
    Analytics.link({
      ...getUtagViewData(),
      link_type: "o",
      link_name: `${Analytics.getUtagData(["page_name"]).page_name}: ${
        props?.upgradeDisplayData?.secondaryCTAText
      }`,
    });
    if (props?.upgradeDisplayData?.secondaryCTAType) {
      const url = `${props?.upgradeDisplayData?.secondaryCTAURL}?bucket=${props?.upgradeDisplayData?.leadType}`;
      navigateTo(url);
    } else {
      navigateTo(props?.upgradeDisplayData?.secondaryCTAURL);
    }
  };

  const ctaText = () => {
    let CTAText = props?.upgradeDisplayData?.primaryCTAText;
    if (
      router.pathname == "/shopping/upgrade" &&
      (props?.upgradeDisplayData?.primaryCTAText === "Choose an upgrade deal" ||
        props?.upgradeDisplayData?.primaryCTAText ===
          "See all deals I qualify for")
    ) {
      CTAText = "Upgrade this number";
    } else if (
      checkifUpgradableAndC3D(props?.resultCode) &&
      props.upgradeLink.text
    ) {
      if (
        unescape(props?.upgradeDisplayData?.primaryCTAText) !==
        "Show me deals I qualify for"
      ) {
        CTAText = props.upgradeLink.text;
      }
    }
    return CTAText;
  };
  const updateSelectedLinkedData = () => {
    const selectedData = props.allUpgradesData.filter((item) => {
      if (maskMsisdn(item.msisdn) === selectedLinkedNumber) {
        return item;
      }
    });
    props.displayHideUpgradeModal(false);
    props.updateEligibiltyCheckStatus(true);
    props.fetchCreditFilters(selectedData[0].msisdn).then(() => {
      props.checkIfdealQualifies();
      props.updateData(selectedData[0]);
    });
    Analytics.setPageName(currentPageName);
    setCurrentPageName("");
  };

  const allLinkedNumbers = () => {
    let numbers = [];
    props.allUpgradesData.forEach((item) => {
      if (item.upgradeEligible) {
        numbers.push(maskMsisdn(item.msisdn));
      }
    });
    return numbers;
  };
  const allSelctedNumber = (value) => {
    setSelectedLinkedNumber(value);
  };
  const eligibleNumbersData = {
    iconUrl: `${imagePrefix}/assets/images/success-circle.svg`,
    title: "Yes! You can upgrade right now!",
    description:
      "The wait is finally over!<br> Which of your upgradeable numbers would you like to upgrade now?",
    primaryButtonText: "Upgrade this number",
    onClickHandlerPrimary: updateSelectedLinkedData,
    mobileNumbers: true,
    numbers: allLinkedNumbers(),
    selectedNumber: selectedLinkedNumber,
    handleOptionClick: allSelctedNumber,
  };

  const userMessage = {
    iconUrl: props?.upgradeDisplayData?.icon || "",
    title: props?.upgradeDisplayData?.resultTitle || "",
    analyticTitle: props?.upgradeDisplayData?.analyticTitle || "",
    description: props?.upgradeDisplayData?.resultHTML
      ? props?.upgradeDisplayData?.resultHTML
      : props?.upgradeDisplayData?.resultText || "",
    infoText: checkUserNextDueDateforUpgrade(props.resultCode)
      ? titleCase(props.upgradeResponse.upgradeDate.toLowerCase())
      : "",
    checkDatabox: checkChildUpgradable(props.resultCode),
    checkDataValue: mahConsentCheck,
    checkBoxDataHandler: updateMahConsentCheck,
    checkBoxData: ToolTipComponent,
    primaryButtonText:
      props?.upgradeDisplayData?.primaryEnabled === "Yes" ? ctaText() : null,
    primaryButtonStyle:
      props?.upgradeDisplayData?.primaryEnabled === "Yes"
        ? checkChildUpgradable(props.resultCode) && !mahConsentCheck
          ? "solid light gray"
          : ""
        : null,
    primaryButtonDisabled:
      props?.upgradeDisplayData?.primaryEnabled === "Yes"
        ? checkChildUpgradable(props.resultCode) && !mahConsentCheck
          ? true
          : false
        : true,
    onClickHandlerPrimary:
      props?.upgradeDisplayData?.primaryEnabled === "Yes"
        ? handleResultCodePrimaryCTA
        : null,
    secondaryButtonText:
      props?.upgradeDisplayData?.secondaryEnabled === "Yes"
        ? props?.upgradeDisplayData.secondaryCTAText
        : null,
    secondaryButtonStyle:
      props?.upgradeDisplayData?.secondaryEnabled === "Yes"
        ? "flat black"
        : null,
    secondaryButtonDisabled:
      props?.upgradeDisplayData?.secondaryEnabled === "Yes" ? false : true,
    onClickHandlerSecondary:
      props?.upgradeDisplayData?.secondaryEnabled === "Yes"
        ? handleResultCodeSecondaryCTA
        : null,
    dropdown:
      resultNumbers.length > 0 &&
      !checkIfHiddenDropdown(props?.upgradeResponse?.resultCode?.toLowerCase()),
    handleVal: handleNewSelect,
    selectedDropdownValue: selectedResultNumber,
    dropdownData: resultNumbers,
    showAddnlInfo: showAddnlInfo,
  };

  useEffect(() => {
    if (!currentPageName) {
      setCurrentPageName(Analytics.getPageName());
    }
    const Data = displayData();
    const userMetaData = Analytics.getProfileData(
      props.userLoggedIn,
      props.profileData,
      props.authDetails
    );
    if (props.showModal) {
      debouncedAnalytics(
        props.resultCode,
        props.journeyStatus,
        Data.analyticTitle,
        Data.title,
        userMetaData,
        Data.showAddnlInfo,
        props.upgradeResponse
      );
    }
  }, [
    props.journeyStatus,
    props.showModal,
    props.resultCode,
    props.upgradeDisplayData,
    props.upgradeResponse,
  ]);

  const viewAnalytics = (
    resultCode,
    journeyStatus,
    analyticTitle,
    modalTitle,
    userMetaData,
    additionalInfo,
    upgradeResponse
  ) => {
    if (
      resultCode &&
      (journeyStatus === upgradeStages.UPGRADE_RESULT ||
        journeyStatus === upgradeStages.TECHNICAL_ERROR)
    ) {
      if (analyticTitle) {
        const upgradeStrategy = upgradeResponse;
        Analytics.view({
          page_event: "view",
          page_name: analyticTitle.replace(/(&#039;)/g, "'"),
          page_channel: "shopping",
          page_master_tab: "personal",
          ...Analytics.getUtagData([
            "page_site_section_lvl_1",
            "page_site_section_lvl_2",
            "page_site_section_lvl_3",
            "page_site_section_lvl_4",
          ]),
          upgrade_eligibility_status: `${
            upgradeStrategy?.upgradeEligible
              ? upgradeStrategy?.upgradeEligible
              : false
          }`,
          upgrade_eligible_date: upgradeStrategy?.upgradeDate || "",
          upgrade_ineligible_reason: !upgradeStrategy?.upgradeEligible
            ? `${modalTitle}`
            : "",
          upgrade_customer_type: !upgradeStrategy
            ? null
            : upgradeStrategy?.c3dCustomer
            ? "C3D"
            : upgradeStrategy?.business
            ? "EBU"
            : "Legacy",
          ...userMetaData,
          upgrade_additional_message: additionalInfo
            ? labels.upgrade.lbl_addnl_info
            : null,
        });
      }
    } else {
      Analytics.view({
        page_event: "view",
        page_name: analyticTitle?.replace(/(&#039;)/g, "'"),
        page_channel: "shopping",
        page_master_tab: "personal",
        ...Analytics.getUtagData([
          "page_site_section_lvl_1",
          "page_site_section_lvl_2",
          "page_site_section_lvl_3",
          "page_site_section_lvl_4",
        ]),
        ...userMetaData,
      });
    }
  };

  const debouncedAnalytics = useCallback(
    debounce(
      (
        resultCode,
        journeyStatus,
        analyticTitle,
        modalTitle,
        userMetaData,
        additionalInfo,
        upgradeResponse
      ) =>
        viewAnalytics(
          resultCode,
          journeyStatus,
          analyticTitle,
          modalTitle,
          userMetaData,
          additionalInfo,
          upgradeResponse
        ),
      500
    ),
    [] // will be created only once initially
  );

  const displayData = () => {
    switch (props.journeyStatus) {
      case upgradeStages.NUMBER_ENRTY:
        return CellNumberInput;
      case upgradeStages.NUMBER_SELECT:
        return linkedNumbersData;
      case upgradeStages.OTP_ENRTY:
        return OTPInput;
      case upgradeStages.UPGRADE_RESULT:
        return userMessage;
      case upgradeStages.TECHNICAL_ERROR:
        return userMessage;
      case upgradeStages.ELIGIBLE_NUMBER_SELECT:
        return eligibleNumbersData;
      default:
        return userMessage;
    }
  };

  const closeErrorToolTip = () => {
    setShowErrorToolTip({ visible: false, message: "" });
    props.displayInvalidOTPError(false);
  };
  // useEffect(() => {
  //   setMsisdn(props.unMaskedMsisdn);
  // }, [props.unMaskedMsisdn]);

  useEffect(() => {
    //do not display upgrade modal popup on first load, especially when changing pages
    props.displayHideUpgradeModal(false);
  }, []);

  return (
    <div>
      {showErrorToolTip.visible && (
        <ErrorTooltip
          errorMsg={showErrorToolTip.message}
          buttonHandler={closeErrorToolTip}
          className={styles.toolTip}
        />
      )}
      {showSnackBar && !isMobile && (
        <SnackBar
          message={labels.upgrade.lbl_otp_resent_info}
          className={"defaultSnackBarStyling"}
          closeSnackBar={closeSnackBar}
          isVisible={showSnackBar}
        />
      )}
      {showSnackBar && isMobile && (
        <SnackBarWithDismiss
          message={labels.upgrade.lbl_otp_resent_info}
          className={"defaultSnackBarStyling"}
          closeSnackBar={closeSnackBar}
          isVisible={showSnackBar}
        />
      )}
      <UpgradeComponent
        showModal={props.showModal}
        displayData={displayData()}
        toggleModal={dismissModal}
      />
      {props.showSnackBar && (
        <SnackBarWithButton
          title={labels.upgrade.lbl_snackbar_title}
          description={labels.upgrade.lbl_snackbar_desc}
          className={`defaultSnackBarStyling ${styles.snackBarStyle}`}
          btnText={labels.upgrade.lbl_snackbar_btn_text}
          closeSnackBar={closeUpgradeSnackBar}
          isVisible={props.showSnackBar}
          buttonHandler={recommendedNavigate}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  showModal: state.upgrade.showModal,
  askForCellNumber: state.upgrade.askForCellNumber,
  canReciveOTP: state.upgrade.canReciveOTP,
  msisdnEntered: state.upgrade.msisdn,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  journeyStatus: state.upgrade.upgradeStatus,
  profileData: state.navDetails.profileData,
  authDetails: state.checkoutDetails.authDetails,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  subscriptions: state.navDetails.subscriptions,
  upgradeResponse: state.upgrade.upgradeResponse,
  invalidOTPTries: state.upgrade.invalidOTPTries,
  linkedNumbersList: state.upgrade.linkedNumbers,
  upgradeDisplayData: state.upgrade.upgradeDisplayData,
  resultCode: state.upgrade.resultCode,
  unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
  allUpgradesData: state.upgrade.allUpgradesData,
  upgradeLink: state.upgrade.upgradeLink,
  checkedBefore: state.upgrade.msisdn,
  showSnackBar: state.upgrade.showSnackBar,
  devicePrice: state.upgrade.devicePrice,
  creditFilters: state.upgrade.creditFilters,
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  isChildAllowed: state.upgrade.isChildAllowed,
  isDisplayInvalidOTPError: state.upgrade.displayInvalidOTPError,
});

export default connect(mapStateToProps, {
  displayHideUpgradeModal,
  clearUpgradeJourney,
  updateCanReciveOTP,
  updateMsisdnStatus,
  updateEligibiltyCheckStatus,
  generateOneTimePin,
  getAllEligibility,
  fetchAlternateNumbers,
  generateOTP,
  getEligibilityForAlternativeNumbers,
  eligibilityForLinkedNumbersList,
  fetchDisplayDetails,
  updateJourneyStatus,
  displayHideUpgradeTopbanner,
  updateSelectedData,
  fetchCreditFilters,
  checkIfdealQualifies,
  resetInvalidOtps,
  toggleSnackBar,
  updateUnmaskedMsisdn,
  updateLinkedNumber,
  getRecommendedDeals,
  displayInvalidOTPError,
  updateData,
  addDealToCart,
  setMaxRecurring
})(UpgradeContainer);
